import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';

export interface ICustomInput {
  label?: string;
  error?: FieldError | undefined | { message: { message: string; value: object } };
  children: React.ReactNode;
  sx?: object;
  rightEl?: { hide?: boolean; sx?: object };
  value?: any;
  errorMessageSx?: object;
  helperText?: string;
  isReadOnly?: boolean;
  isRequired?: boolean;
}

export const CustomFormControl = (props: ICustomInput) => {
  const { t } = useTranslation();
  const { label, error, children, sx, rightEl, value, errorMessageSx, helperText, isReadOnly, isRequired } = props;

  const translateErrorMessage = () => {
    if (error?.message) {
      if (typeof error?.message === 'string') {
        return t(`${error?.message}`);
      }
      return t(`${error?.message?.message}`, error?.message?.value);
    }
    return null;
  };

  return (
    <FormControl
      isInvalid={!!error}
      sx={sx}
      _focusWithin={{ zIndex: 'dropdown' }}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
    >
      {label ? <FormLabel fontWeight={400}>{label}</FormLabel> : null}
      <InputGroup>
        {children}
        {rightEl?.hide || error || !value ? null : (
          <InputRightElement pointerEvents='none' children={<FiCheck />} sx={rightEl?.sx} />
        )}
      </InputGroup>

      {String(error?.message).trim().length ? (
        <FormErrorMessage fontSize='xs' color='brand.pink' mt={0} sx={errorMessageSx}>
          *&nbsp;{translateErrorMessage()}
        </FormErrorMessage>
      ) : null}
      {helperText ? (
        <FormHelperText mt='0' textAlign='left' fontSize='xs' color='gray.400'>
          *&nbsp;{helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};
